module.exports = __webpack_public_path__ + "img/logo.3b7e10a2.png";